import {
  Box,
  Center,
  Checkbox,
  CheckboxGroup,
  Flex,
  FormControl,
  FormLabel,
} from "@chakra-ui/react";
import React from "react";
import { InputConsulta, SelectConsulta } from "./styles";

const FormConsulta = (data) => {
  return (
    <>
      <Flex mt="3rem">
        <FormControl ml="1rem" mr="1rem" variant="floating">
          <InputConsulta
            focusBorderColor="#80bd01"
            size="md"
            type="text"
            placeholder=" "
            onChange={(e) => data.onChange(e, "numero_proposta")}
          />
          <FormLabel color="gray.400">Número da Proposta</FormLabel>
        </FormControl>

        <FormControl ml="1rem" mr="1rem" variant="floating">
          <InputConsulta
            focusBorderColor="#80bd01"
            size="md"
            type="text"
            placeholder=" "
            onChange={(e) => data.onChange(e, "nome_parceiro")}
          />
          <FormLabel color="gray.400">Nome do Parceiro</FormLabel>
        </FormControl>
        <FormControl ml="1rem" mr="1rem" variant="floating">
          <InputConsulta
            focusBorderColor="#80bd01"
            size="md"
            type="text"
            placeholder=" "
            onChange={(e) => data.onChange(e, "nome_cliente")}
          />
          <FormLabel color="gray.400">Nome do Cliente</FormLabel>
        </FormControl>
      </Flex>
      <Flex mt="3rem">
        <FormControl ml="1rem" mr="1rem" variant="floating">
          <InputConsulta
            focusBorderColor="#80bd01"
            size="md"
            type="text"
            placeholder=" "
            onChange={(e) => data.onChange(e, "codigo_parceiro")}
          />
          <FormLabel color="gray.400">Código do Parceiro</FormLabel>
        </FormControl>
        <FormControl ml="1rem" mr="1rem" variant="floating">
          <InputConsulta
            focusBorderColor="#80bd01"
            size="md"
            value={data.state.cpf_cnpj_parceiro}
            type="text"
            placeholder=" "
            onChange={(e) => data.onChange(e, "cpf_cnpj_parceiro", "mask")}
          />
          <FormLabel color="gray.400">CPF/CNPJ</FormLabel>
        </FormControl>
        <FormControl ml="1rem" mr="1rem" variant="floating">
          <InputConsulta
            focusBorderColor="#80bd01"
            size="md"
            type="text"
            placeholder=" "
            onChange={(e) => data.onChange(e, "email_parceiro")}
          />
          <FormLabel color="gray.400">E-mail</FormLabel>
        </FormControl>
      </Flex>
      <Flex mt="3rem">
        <FormControl ml="1rem" mr="1rem" variant="floating">
          <InputConsulta
            focusBorderColor="#80bd01"
            size="md"
            type="text"
            placeholder=" "
            onChange={(e) => data.onChange(e, "codigo_status_pedido")}
          />
          <FormLabel color="gray.400">Código do Produto</FormLabel>
        </FormControl>
        <SelectConsulta
          _active={{ color: "#80bd01" }}
          focusBorderColor="#80bd01"
          color="gray.400"
          mr="1rem"
          ml="1rem"
          size="md"
          onChange={(e) => data.onChange(e, "estimativa_valor", "select")}
          defaultValue={""}
        >
          <option value={0}>Selecionar Estimativa</option>
          <option value={1}>Propostas até R$ 1 mil</option>
          <option value={2}>Propostas até R$ 5 mil</option>
          <option value={3}>Propostas até R$ 10 mil</option>
          <option value={4}>Propostas até R$ 30 mil</option>
          <option value={5}>Propostas acima R$ 30 mil</option>
        </SelectConsulta>
        <SelectConsulta
          _active={{ color: "#80bd01" }}
          focusBorderColor="#80bd01"
          color="gray.400"
          placeholder="Status Funil"
          mr="1rem"
          ml="1rem"
          size="md"
          onChange={(e) => data.onChange(e, "codigo_status_pedido", "select")}
          defaultValue={""}
        >
          {data.state.funilVendas.map((funil) => {
            if (funil.codigo_funil_venda !== "11")
              return (
                <option value={funil.codigo_funil_venda}>
                  {funil.tipo_funil_venda}
                </option>
              );
          })}
        </SelectConsulta>
      </Flex>
      <Flex mt="3rem">
        <Flex w="100%" justifyContent="center" alignItems="center" gap={2}>
          <Box>
            <FormControl ml="1rem" mr="1rem" variant="floating">
              <InputConsulta
                focusBorderColor="#80bd01"
                size="md"
                type="date"
                color="gray.400"
                w="205px"
                mr="2rem"
                onChange={(e) => data.onChange(e, "data_inicio")}
              />
              <FormLabel color="gray.400">De</FormLabel>
            </FormControl>
          </Box>

          <Box>
            <FormControl ml="1rem" mr="1rem" variant="floating">
              <InputConsulta
                focusBorderColor="#80bd01"
                size="md"
                type="date"
                w="205px"
                color="gray.400"
                onChange={(e) => data.onChange(e, "data_fim")}
              />
              <FormLabel color="gray.400">Até</FormLabel>
            </FormControl>
          </Box>
        </Flex>
      </Flex>

      <Center>
        <Flex mt="1rem">
          <CheckboxGroup>
            <Checkbox
              color="gray.400"
              iconColor="#80bd01"
              colorScheme="whiteAlpha"
              p="6"
              type="radio"
              borderColor="gray.400"
              onChange={(e) => data.onChange(e, "pendente", "checked")}
            >
              Orçamento a Enviar
            </Checkbox>
            <Checkbox
              color="gray.400"
              iconColor="#80bd01"
              colorScheme="whiteAlpha"
              p="6"
              type="radio"
              borderColor="gray.400"
              onChange={(e) => data.onChange(e, "proposta_especial", "checked")}
            >
              Proposta Especial
            </Checkbox>
            <Checkbox
              color="gray.400"
              iconColor="#80bd01"
              colorScheme="whiteAlpha"
              p="6"
              type="radio"
              borderColor="gray.400"
              onChange={(e) => data.onChange(e, "orcamentos_ativos", "checked")}
            >
              Orçamentos Ativos
            </Checkbox>
            <Checkbox
              color="gray.400"
              iconColor="#80bd01"
              colorScheme="whiteAlpha"
              p="6"
              type="radio"
              borderColor="gray.400"
              onChange={(e) => data.onChange(e, "pendente", "checked")}
            >
              Filtrar todos
            </Checkbox>
          </CheckboxGroup>
        </Flex>
      </Center>
    </>
  );
};

export default FormConsulta;
